import XcolumnFunc from "@/pcomponents/common/xcolumn/xcolumn/xcolumn_func";
//const xColumnArr=getXcolumnJson();

const getXcolumnJson=()=>{
  let initData:any={
    table:"mtextbook",
    list_id:"find_mtextbook_list",
    x_column_list_arr:[
      {"key":"a_title","name":"제목","width":"180","is_show":"1"},
      {"key":"a_subject","name":"과목","width":"80","is_show":"1"},
      {"key":"row_view_category","name":"카테고리","width":"110","is_show":"1"},
      {"key":"row_view_sort1","name":"대분류","width":"100","is_show":"1"},
      {"key":"row_view_sort2","name":"중분류","width":"100","is_show":"1"},
      {"key":"row_view_sort3","name":"소분류","width":"100","is_show":"1"},
      {"key":"row_view_stock_cnt","name":"재고","width":"80","is_show":""},
      {"key":"row_view_price","name":"가격","width":"110","is_show":""},
      {"key":"row_view_price_use","name":"온라인","width":"80","is_show":""},
      {"key":"row_view_word_count","name":"단어수","width":"80","is_show":""},
    ],
    list_opt_origin:{
      'now_page':1,
      'num_per_page':10,
      'order_id':'a_title',
      'order_type':'',
      's_date_type':'',
      's_start_date':'',
      's_end_date':'',
      'sc':{},
    },
    order_id_col_arr:[
      {"value":"","text":"없음"},
    ]
  };
  initData.pri_col_arr=["a_seq"];
  const xColumnArr:any=XcolumnFunc.getDefaultXcolumn(initData);

  return xColumnArr;
};

export default getXcolumnJson;